import Card from '../Reusable/Card'
import APIS from '../../constant/EndPoint'
import useGetHook from '../../customHooks/useGetHook'
import { classNames } from '../../utils/classNames'

const GridCard = (props: any) => {
  const { item, handleOpenEditPopup, onClick, props: filterPrams, selectedCardItems } = props

  const isActive = selectedCardItems[item?.slug?.replaceAll("-", "_")]
  const { data: userProfileType } = useGetHook({
    queryKey: [`user-profile`],
    url: `${APIS.USER_PROFILE}`,
    params: {},
  });

  const { data: gridDataInfo } = useGetHook({
    queryKey: [`${item?.slug}-${JSON.stringify(filterPrams)}`],
    url: `${APIS.GRID_REPORT_DATA}resolve-report/`,
    params: {
      slug: item?.slug,
      ...filterPrams
    },
  });
  return (
    <Card title={item?.name} onClick={() => onClick(item?.slug)}>
      <div className={classNames(isActive ? "bg-primary text-white" : "")}>
        <div className={'flex justify-between mx-auto mt-4 pr-2'} >
          <div className='font-medium text-xl'>{gridDataInfo?.count}</div>
          <div className='font-medium text-2xl'>Rs.{gridDataInfo?.amount}</div>
        </div>
        {userProfileType?.is_superuser ?
          <>
            <div className='w-full text-center p-1 cursor-pointer bg-gray-100 text-black' onClick={() => handleOpenEditPopup(item)}>
              Edit
            </div>
          </>
          : ""}
      </div>
    </Card>
  )
}

export default GridCard
